/**
 * theme-slider-base.js
 * Base slider functionality - horizontal-loop + slider utilities
 * This bundle is required by all slider types
 * 
 * NOTE: GSAP plugins (Draggable, InertiaPlugin) loaded from theme-core
 * Size: ~15KB minified (was 115KB with duplicated GSAP)
 * Load: Asynchronous, non-blocking
 * Triggers: Any slider element detected
 * Depends: theme-core.js (must load first)
 */

// Prevent duplicate initialization - early exit if already loaded
if (window.sliderBase) {
  console.log('[Slider Base] Already loaded - skipping duplicate');
} else {
  // Use GSAP from window (loaded in core bundle)
  const { gsap, Draggable, InertiaPlugin, ScrollTrigger } = window;

  if (!gsap || !Draggable || !InertiaPlugin) {
    console.error('[Slider Base] Missing dependencies! Ensure theme-core.js loads first.');
  }

  // Import horizontal loop (used by all sliders)
  // Note: These imports are hoisted, but the code below only runs once
  
  console.log('[Slider Base] Loaded - Draggable, InertiaPlugin, horizontalLoop available');
}

// Imports must be at top level
import { horizontalLoop } from '../modules/slider/horizontal-loop.js';
import { createSliderControls, createSliderProgressBar, createVisibilityDetection } from '../modules/slider/slider-utils.js';

// Only set up exports once
if (!window.sliderBase) {
  // Export base functionality
  window.sliderBase = {
    horizontalLoop,
    createSliderControls,
    createSliderProgressBar,
    createVisibilityDetection,
    Draggable: window.Draggable,
    InertiaPlugin: window.InertiaPlugin,
  };

  // Initialize slider registry
  window.sliderInstances = window.sliderInstances || [];

  /**
   * Expose utility functions globally for block compatibility
   * Required by custom blocks like g2n-slider
   */
  window.refreshAllSliders = function(newSettings = {}) {
    if (window.sliderInstances && window.sliderInstances.length) {
      window.sliderInstances.forEach((instance) => {
        if (typeof instance.refresh === 'function') {
          instance.refresh(newSettings);
        }
      });
    }
  };

  window.destroyAllSliders = function() {
    if (window.sliderInstances && window.sliderInstances.length) {
      [...window.sliderInstances].forEach((instance) => {
        if (typeof instance.destroy === 'function') {
          instance.destroy();
        }
      });
      window.sliderInstances = [];
    }
  };
}